const MOBILE_OS = {
  WIN_PHONE: 'Windows Phone',
  ANDROID: 'Android',
  IOS: 'iOS',
  UNKNOWN: 'unknown',
};

export { MOBILE_OS };
